"use strict";

export default function offcanvas() {
    return {
        open: false,
        usedKeyboard: false,
        init() {
            this.$watch('open', () => {
                this.toggleOverlay();
            })
            this.toggleOverlay();
        },
        toggleOverlay() {
            document.body.classList[this.open ? 'add' : 'remove']('h-screen', 'overflow-hidden');
        }
    }
}
